import size from 'lodash/size';
export class DynamicMenusService {
	constructor($resource, ApiService, BreadcrumbService) {
		'ngInject';

		this.$resource = $resource;
		this.apiService = ApiService;
		this.breadcrumbService = BreadcrumbService;
	}

	//***************************************Public Methods*************************** */
	getMenuDetailsByUrl(url) {
		url = url || 'home';
		this.dynamicPageResourceUrl = this.apiService.getResourceUrl(`menus/${url}`);
		this.dynamicPageResource = this.$resource(this.dynamicPageResourceUrl);

		const promise = this.dynamicPageResource.get().$promise;
		return promise
			.then(details => {
				size(details.data) > 0 ? this._setPageBreadcrumb(details) : true;
				return details;
			})
			.catch(err => {
				throw this.apiService.getErrorMessage(err);
			});
	}

	getPageNotFoundPageBreadcrumb() {
		return [{
			name: 'PageNotFound',
			display_name: 'Page Not Found',
			slug: ''
		}];
	}

	//Get Parent State Object
	getParentStateObject() {
		const breadcrumbs = this.breadcrumbService.breadcrumbs;
		const sizeOfBreadcrumbs = size(breadcrumbs);

		return sizeOfBreadcrumbs > 0 ? breadcrumbs[(sizeOfBreadcrumbs - 1) - 1] : breadcrumbs[sizeOfBreadcrumbs];
	}

	//***************************************Private Methods************************** */

	_setPageBreadcrumb({ data: { breadcrumb } }) {
		breadcrumb = breadcrumb ? breadcrumb : [];
		this.breadcrumbService.setPageBreadcrumbs(breadcrumb);
	}
}


// WEBPACK FOOTER //
// ./src/app/components/dynamic-menus/dynamic-menus.service.js